import { useMutation } from '@tanstack/react-query';
import { resourcefulRequest } from './requests'

export function useReminderRequestMutation(feature) {
  const requests = resourcefulRequest('reminder_request')

  return useMutation((feature) => requests.create({ reminder_request: { feature } }));
}
